import StandardError from '../StandardError'

export default class Received5Days extends StandardError {
  constructor() {
    super(
      'This item was marked as received more than 5 days ago and is no longer eligible for a return. Thanks for understanding.'
    )
  }
}
